import {
  DEMO_MODE,
  IAccountDetailResponse,
  IAccountMutationForm,
} from 'services/accounts/types';
import { CLIENT_ACCESS_MODE, CURRENCY } from 'services/types';
import { formatDateToInput } from 'utils/global/date.utils';

export const accountQueryToForm = (
  accountQuery: IAccountDetailResponse,
): IAccountMutationForm => {
  const license = accountQuery.license;

  return {
    id: accountQuery.id,
    withLicense: !!license,
    accountName: accountQuery.accountName,
    endpoint: accountQuery.endpoint || '',
    clientEndpoint: accountQuery.clientEndpoint || '',
    apiKey: accountQuery.apiKey || '',
    email: license?.email || '',
    firstName: license?.firstName || '',
    lastName: license?.lastName || '',
    name: license?.name || '',
    fullName: license?.fullName || '',
    phoneNumberPrefix: license?.phoneNumberPrefix || '',
    phoneNumber: license?.phoneNumber || '',
    availableFrom: formatDateToInput(
      license?.availableFrom || new Date(),
      true,
    ),
    availableTo: formatDateToInput(license?.availableTo || '', true),
    withEndDate: !!license?.availableTo,
    defaultCurrencyId: license?.defaultCurrencyId ?? CURRENCY.EUR,
    deliveryCode: license?.deliveryCode || 0,
    clientAccessModeId:
      license?.clientAccessModeId || CLIENT_ACCESS_MODE.Passive,
    isrcGenerationMode: license?.isrcGenerationMode ?? 1,
    showOwnersLogoAsMain: license?.showOwnersLogoAsMain || false,
    clientModuleAccess: license?.clientModuleAccess || false,
    enableDigitalDelivery: license?.enableDigitalDelivery || false,
    availableSettlementMethods: license?.availableSettlementMethods || [],
    availableServices: license?.availableServices || [],
    smartlinkDomains: license?.smartlinkDomains || [],
    availableStatementTemplates: [],
    availableStatementTemplateIds: license?.availableStatementTemplateIds || [],
    address: {
      street: license?.address?.street || '',
      houseNumber: license?.address?.houseNumber || '',
      flatNumber: license?.address?.flatNumber || '',
      zipCode: license?.address?.zipCode || '',
      city: license?.address?.city || '',
      countryAlfa2: license?.address?.countryAlfa2 || '',
    },
    taxOffice: {
      name: license?.taxOffice?.name || '',
      street: license?.taxOffice?.street || '',
      houseNumber: license?.taxOffice?.houseNumber || '',
      flatNumber: license?.taxOffice?.flatNumber || '',
      zipCode: license?.taxOffice?.zipCode || '',
      city: license?.taxOffice?.city || '',
      countryAlfa2: license?.taxOffice?.countryAlfa2 || '',
    },
    companyId: license?.companyId || '',
    companyCountryAlfa2: license?.companyCountryAlfa2 || '',
    bankAccountNumber: license?.bankAccountNumber || '',
    bankName: license?.bankName || '',
    swift: license?.swift || '',
    isDemo: license?.demoModeId != null,
    demoModeId: license?.demoModeId ?? DEMO_MODE.client,
  };
};
